(function () {
  'use strict';

  /* ============================================================
     GM WATCHES — CART DRAWER CONTROLLER
     VERSION 3.2.9 (Sticky Footer, Green Shipping Bar)
     ============================================================ */

  var GM = window.GMCartDrawer || {};
  var GM_VERSION = '3.4.2';

  /*
   * Prevent duplicate initialization when the same asset is evaluated more
   * than once. The previous guard checked 3.4.0 while the controller itself
   * reported 3.4.1, so it could never stop a duplicate boot.
   */
  if (GM.version === GM_VERSION && GM.initialized) {
    return;
  }

  GM.version = GM_VERSION;
  window.GMCartDrawer = GM;

  var initialized = false;
  var cartRequestBusy = false;
  var cartFetchPromise = null;
  var lastCartEventAt = 0;
  var afterAddPromise = null;

  /* ============================================================
     HELPERS
  ============================================================ */
  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' EGP';
  }

  function getDrawer() {
    return qs('[data-gm-cart-drawer]');
  }

  function getPanel(drawer) {
    return qs('[data-gm-cart-drawer-panel], [data-gm-cart-panel]', drawer || document);
  }

  function getShippingSettings(drawer) {
    var shipping = qs('[data-gm-cart-shipping]', drawer || document);
    if (!shipping) {
      return null;
    }
    var thresholdCents = Number(shipping.dataset.gmShippingThreshold);
    var threshold = Number.isFinite(thresholdCents) && thresholdCents > 0 ? thresholdCents / 100 : 0;
    
    return {
      threshold: threshold,
      approachingText: shipping.dataset.gmShippingApproachingText || '',
      successText: shipping.dataset.gmShippingSuccessText || '',
      successColor: shipping.dataset.gmShippingSuccessColor || '',
      successSize: shipping.dataset.gmShippingSuccessSize || '',
      successWeight: shipping.dataset.gmShippingSuccessWeight || ''
    };
  }

  function isInsideDrawer(element) {
    var drawer = getDrawer();
    return !!(drawer && element && drawer.contains(element));
  }

  /* ============================================================
     ADD TO CART HELPERS
  ============================================================ */
  function getAddForm(button) {
    if (!button) return null;
    if (button.form) return button.form;
    return button.closest('form[action*="/cart/add"], form.gm-buy-form, form[data-buy-form], form');
  }

  function isAddButton(button) {
    if (!button || !button.matches) return false;

    var tagName = button.tagName.toLowerCase();
    var href = button.getAttribute('href') || '';

    if (tagName === 'a' && href) {
        if (href.indexOf('/products/') !== -1 || href.indexOf('/collections/') !== -1) {
            return false;
        }
    }

    var selector = [
      'button[name="add"]',
      'button[type="submit"][name="add"]',
      'input[type="submit"][name="add"]',
      '[data-add-to-cart]',
      '[data-cart-add]',
      '[data-add-product]',
      '[data-add-to-cart-button]',
      '.product-form__submit',
      '.quick-add__submit',
      '.product-card__add-to-cart',
      '.card__add-to-cart',
      '.gm-add-to-cart',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      'a[href*="/cart/add"]'
    ].join(',');

    if (button.matches(selector)) return true;

    if (tagName === 'button' || tagName === 'input') {
        var form = getAddForm(button);
        if (form && form.matches && form.matches('form[action*="/cart/add"], form.gm-buy-form, form[data-buy-form]')) {
            return true;
        }
    }

    var text = (button.textContent || button.value || '').trim().toLowerCase();
    var addWords = ['add to cart', 'أضف إلى السلة', 'اضف الى السلة', 'أضف للسلة', 'اضف للسلة', 'إضافة للسلة', 'اضافة للسلة'];
    var buyWords = ['buy now', 'اشتر الآن', 'اشترى الآن', 'شراء الآن', 'اشترِ الآن', 'اشترى', 'اشتر الآن'];
    
    var hasAddWord = addWords.some(function (word) { return text.indexOf(word) !== -1; });
    var hasBuyWord = buyWords.some(function (word) { return text.indexOf(word) !== -1; });

    if (hasAddWord && !hasBuyWord) {
        if (tagName === 'button' || (tagName === 'a' && (!href || href === '#' || href === 'javascript:void(0)'))) {
            return true;
        }
    }

    return false;
  }

  function getFormData(form) {
    if (!form) return null;
    var data = new FormData(form);
    var id = data.get('id');

    if (!id) {
      var idInput = qs('[name="id"], [data-variant-id]', form);
      if (idInput) {
        id = idInput.value || idInput.dataset.variantId;
      }
    }
    if (!id) return null;

    var quantity = data.get('quantity');
    quantity = parseInt(quantity, 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    data.set('id', String(id));
    data.set('quantity', String(quantity));
    return data;
  }

  function getVariantIdFromElement(element) {
    if (!element) return null;
    var direct = element.dataset && (element.dataset.variantId || element.dataset.variant || element.dataset.id);
    if (direct) return direct;

    var attr = element.getAttribute('data-variant-id') || element.getAttribute('data-variant') || element.getAttribute('data-id');
    if (attr) return attr;

    var idInput = element.matches && element.matches('[name="id"]') ? element : (element.querySelector && element.querySelector('[name="id"], [data-variant-id]'));
    if (idInput) return (idInput.value || idInput.getAttribute('data-variant-id'));

    var parent = element.closest && element.closest('[data-variant-id], [data-variant], [data-id]');
    if (parent) return (parent.getAttribute('data-variant-id') || parent.getAttribute('data-variant') || parent.getAttribute('data-id'));

    var href = element.getAttribute && element.getAttribute('href');
    if (href) {
      try {
        var url = new URL(href, window.location.origin);
        return (url.searchParams.get('id') || url.searchParams.get('variant'));
      } catch (error) {}
    }
    return null;
  }

  function getProductHandleFromElement(element) {
    if (!element) return null;
    var link = element.closest && element.closest('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : (element.getAttribute && element.getAttribute('href'));

    if (!href) {
      var holder = element.closest && element.closest('[data-product-handle]');
      return holder ? holder.getAttribute('data-product-handle') : null;
    }

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) { return null; }
  }

  function getQuantityFromElement(element, form) {
    var quantity = null;
    if (form) {
      var quantityInput = qs('[name="quantity"]', form);
      if (quantityInput) quantity = quantityInput.value;
    }
    if (!quantity && element) {
      quantity = element.getAttribute('data-quantity');
    }
    quantity = parseInt(quantity || '1', 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    return quantity;
  }

  function resolveVariantId(button, form) {
    var direct = getVariantIdFromElement(button) || getVariantIdFromElement(form);
    if (direct) return Promise.resolve(direct);

    var handle = getProductHandleFromElement(button) || getProductHandleFromElement(form);
    if (!handle) return Promise.resolve(null);

    return fetch('/products/' + encodeURIComponent(handle) + '.js?_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('تعذر قراءة بيانات المنتج.');
        return response.json();
      })
      .then(function (product) {
        var variants = product && product.variants ? product.variants : [];
        var available = variants.find(function (variant) { return variant.available; });
        return available ? available.id : (variants[0] ? variants[0].id : null);
      })
      .catch(function () { return null; });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', !!loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if ('disabled' in button) button.disabled = !!loading;
  }

  /* ============================================================
     NETWORK INTERCEPTORS
     ============================================================

     GM no longer monkey-patches window.fetch or XMLHttpRequest.
     Add-to-cart requests created by this controller already flow through
     handleDirectAdd(), so a global interceptor is unnecessary and can
     duplicate cart refreshes or interfere with Shopify/theme apps.
   */

  /* ============================================================
     SHOPIFY CART API
  ============================================================ */
  function addToShopifyCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = {};
          try { data = text ? JSON.parse(text) : {}; } catch (error) { data = {}; }
          if (!response.ok) {
            throw new Error(data.description || data.message || 'تعذر إضافة المنتج إلى السلة.');
          }
          return data;
        });
      });
  }

  function addVariantToShopifyCart(variantId, quantity) {
    var data = new FormData();
    data.set('id', String(variantId));
    data.set('quantity', String(quantity || 1));
    return addToShopifyCart(data);
  }

  function fetchCart() {
    /*
     * Deduplicate simultaneous /cart.js reads.
     * Several Shopify/theme events can arrive for the same cart action;
     * sharing the in-flight promise avoids duplicate network requests
     * without introducing stale cart caching.
     */
    if (cartFetchPromise) return cartFetchPromise;

    cartFetchPromise = fetch('/cart.js?_=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .finally(function () {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  /* ============================================================
     OPEN / CLOSE
  ============================================================ */
  function open() {
    var drawer = getDrawer();
    if (!drawer) {
      return false;
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gm-cart-drawer-open');
    return true;
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gm-cart-drawer-open');
  }

  /* ============================================================
     AFTER ADD
  ============================================================ */
  function afterAdd() {
    /* If another GM/Shopify path already refreshed the cart moments ago,
       let its cart event update the drawer instead of fetching again. */
    if (Date.now() - lastCartEventAt < 350) {
      return Promise.resolve();
    }

    if (afterAddPromise) return afterAddPromise;

    afterAddPromise = fetchCart().then(function (cart) {
      renderProducts(cart);
      updateShipping(cart);
      updateSummary(cart);
      updateCartBubble(cart);
      updateEmptyState(cart);
      renderAOV(cart);
      open();
      dispatchCartEvents(cart);
      return cart;
    }).finally(function () {
      afterAddPromise = null;
    });

    return afterAddPromise;
  }

  function handleDirectAdd(button, form) {
    if (cartRequestBusy) return;
    cartRequestBusy = true;
    setButtonLoading(button, true);
    open(); 

    var data = form ? getFormData(form) : null;
    var quantity = getQuantityFromElement(button, form);

    resolveVariantId(button, form)
      .then(function (variantId) {
        if (!variantId) throw new Error('مش لاقي Variant ID للمنتج ده.');
        if (!data) return addVariantToShopifyCart(variantId, quantity);
        data.set('id', String(variantId));
        data.set('quantity', String(quantity));
        return addToShopifyCart(data);
      })
      .then(afterAdd)
      .catch(function (error) {
        console.error('GM Cart Drawer Add:', error);
        var message = form && qs('[data-buy-message]', form);
        if (message) {
          message.textContent = error.message || 'حصلت مشكلة، حاول تاني.';
        }
      })
      .finally(function () {
        cartRequestBusy = false;
        setButtonLoading(button, false);
      });
  }

  /* ============================================================
     GLOBAL EVENTS
  ============================================================ */
  function bindGlobalEvents() {
    if (initialized) return;
    initialized = true;

    /* ----------------------------------------------------------
       CAPTURE CLICK (تجميد الضغطة لو بره السلة)
    ---------------------------------------------------------- */
    document.addEventListener('click', function(event) {
      var drawer = getDrawer();
      if (!drawer) return;

      var isOpen = document.body.classList.contains('gm-cart-drawer-open') || drawer.classList.contains('is-open');
      if (!isOpen) return;

      var panel = getPanel(drawer);
      var isOutsidePanel = panel && !panel.contains(event.target);

      // لو الضغطة خارج المربع الأبيض، اجمد الضغطة واقفل السلة
      if (isOutsidePanel) {
        event.preventDefault();
        event.stopPropagation();
        close();
      }
    }, true); // ← 'true' هنا هي السر! بتصطاد الضغطة قبل ما تنفذ أي وظيفة في الموقع

    /* ----------------------------------------------------------
       BUBBLING CLICK
    ---------------------------------------------------------- */
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button, input, a, [role="button"]') : null;
      if (!target) return;
      if (isInsideDrawer(target)) return;

      if (isAddButton(target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var form = getAddForm(target);
        handleDirectAdd(target, form);
        return;
      }

      var cartActionLink = target.closest([
        'a[href*="/cart/change"]',
        'a[href*="/cart/update"]',
        'a[href*="/cart/clear"]',
        'a[href*="/cart/add"]'
      ].join(','));
      
      if (cartActionLink) return;

      var cartTrigger = target.closest([
        'a[href="/cart"]',
        'a[href^="/cart?"]',
        'a[href*="/cart/"]',
        '[data-cart-icon]',
        '[data-cart-drawer-trigger]',
        '[aria-controls="cart-drawer"]',
        '[aria-label="سلة"]',
        '[aria-label="السلة"]',
        '[aria-label="cart"]',
        '[aria-label="Cart"]',
        '[aria-label="View cart"]',
        '[aria-label="view cart"]',
        '.header__icon--cart',
        '.cart-link',
        '.cart-icon-bubble'
      ].join(','));

      if (cartTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        fetchCart().then(function (cart) {
          renderProducts(cart);
          updateShipping(cart);
          updateSummary(cart);
          updateCartBubble(cart);
          updateEmptyState(cart);
          open();
        }).catch(function (error) {
          console.error('GM Cart Drawer Open:', error);
          open();
        });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (isInsideDrawer(form)) return;
      if (!form.matches('form[action*="/cart/add"], form.gm-buy-form, form[data-buy-form]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      var button = qs('[data-add-to-cart], button[name="add"], button[type="submit"], input[type="submit"]', form);
      handleDirectAdd(button, form);
    }, true);

    document.addEventListener('gm:cart-updated', function (event) {
      lastCartEventAt = Date.now();
      var cart = event && event.detail && event.detail.cart;
      if (!cart) {
        refreshCart().catch(function () {});
        return;
      }
      renderProducts(cart);
      updateShipping(cart);
      updateSummary(cart);
      updateCartBubble(cart);
      updateEmptyState(cart);
    });

    document.addEventListener('cart:updated', function (event) {
      lastCartEventAt = Date.now();
      var cart = event && event.detail && event.detail.cart;
      if (cart) {
        renderProducts(cart);
        updateShipping(cart);
        updateSummary(cart);
        updateCartBubble(cart);
        updateEmptyState(cart);
        renderAOV(cart);
      } else {
        refreshCart().catch(function () {});
      }
    });

    document.addEventListener('cart:refresh', function () {
      refreshCart().catch(function () {});
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var aov = getAOVSection();
        var quickView = aov && getAOVQuickView(aov);
        if (quickView && !quickView.hidden) {
          closeAOVQuickView(aov);
          return;
        }
        close();
      }
    });
  }

  /* ============================================================
     DRAWER EVENTS
  ============================================================ */
  function bindDrawerEvents() {
    var drawer = getDrawer();
    if (!drawer) return;
    if (drawer.dataset.gmEventsBound === 'true') return;
    drawer.dataset.gmEventsBound = 'true';

    drawer.addEventListener('click', function (event) {
      var closeButton = event.target.closest('[data-gm-cart-drawer-close], [data-gm-cart-close]');
      var overlay = event.target.closest('[data-gm-cart-drawer-overlay], [data-gm-cart-overlay]');

      // التحقق الإضافي للتأكد إن لو الزرار جوه السلة بيقفلها بسلاسة
      if (closeButton || overlay || event.target === drawer) {
        event.preventDefault();
        close();
        return;
      }

      var viewCart = event.target.closest('[data-gm-cart-view]');
      if (viewCart) {
        event.preventDefault();
        window.location.assign('/cart');
        return;
      }

      var checkout = event.target.closest('[data-gm-cart-checkout]');
      if (checkout) {
        event.preventDefault();
        fetchCart().then(function (cart) {
          goToCheckout(cart);
        }).catch(function () {
          window.location.assign('/checkout');
        });
        return;
      }
    });
  }

  /* ============================================================
     REFRESH CART UI
  ============================================================ */
  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderProducts(cart);
      updateShipping(cart);
      updateSummary(cart);
      updateCartBubble(cart);
      updateEmptyState(cart);
      renderAOV(cart);
      return cart;
    }).catch(function (error) {
      console.error('GM Cart Drawer:', error);
      throw error;
    });
  }

  /* ============================================================
     PRODUCTS & UI RENDERING
  ============================================================ */
function renderProducts(cart) {
  var drawer = getDrawer();
  var list = qs('[data-gm-cart-drawer-product-list], [data-gm-cart-items]', drawer || document);
  var empty = qs('[data-gm-cart-drawer-empty], [data-gm-cart-empty]', drawer || document);

  if (!list) return;
  list.innerHTML = '';

  if (!cart.items || !cart.items.length) {
    showEmptyState(empty);
    return;
  }

  hideEmptyState(empty);

  cart.items.forEach(function (item) {
    var product = document.createElement('article');
    product.className = 'gm-cart-drawer-product';
    product.dataset.gmCartKey = item.key;

    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

    /*
     * مهم جدًا:
     * السعر الحالي هنا هو سعر المنتج نفسه (item.price)، وليس خصم العرض 5%/10%.
     * السعر المشطوب لا يأتي من original_price لأنه قد يمثل سعرًا قبل خصم Shopify.
     * Compare-at الحقيقي يتم جلبه من بيانات المنتج عند الحاجة.
     */
    var currentPrice = Number(item.price || item.final_price || 0);
    var compareAtPrice = Number(item.compare_at_price || 0);
    var hasCompareAt = compareAtPrice > currentPrice && compareAtPrice > 0;

    var priceHtml = '';
    if (hasCompareAt) {
      priceHtml = `
        <strong class="gm-cart-drawer-product__price">${formatMoney(currentPrice)}</strong>
        <del class="gm-cart-drawer-product__compare">${formatMoney(compareAtPrice)}</del>
      `;
    } else {
      priceHtml = `<strong class="gm-cart-drawer-product__price">${formatMoney(currentPrice)}</strong>`;
    }

    product.innerHTML = `
      <button type="button" class="gm-cart-drawer-product__close" data-gm-remove data-key="${escapeHtml(item.key)}" aria-label="حذف المنتج نهائياً">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12"></path>
          <path d="M18 6L6 18"></path>
        </svg>
      </button>
      <div class="gm-cart-drawer-product__image">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
      </div>
      <div class="gm-cart-drawer-product__info">
        ${item.url
          ? `<a class="gm-cart-drawer-product__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title || '')}</a>`
          : `<div class="gm-cart-drawer-product__title">${escapeHtml(item.product_title || '')}</div>`}
        ${variant ? `<div class="gm-cart-drawer-product__variant">${escapeHtml(variant)}</div>` : ''}

        <div class="gm-cart-drawer-product__prices">
          ${priceHtml}
        </div>

        <div class="gm-cart-drawer-product__controls">
          <button type="button" data-gm-qty-minus data-key="${escapeHtml(item.key)}" aria-label="تقليل الكمية">−</button>
          <span data-gm-quantity>${Number(item.quantity || 0)}</span>
          <button type="button" data-gm-qty-plus data-key="${escapeHtml(item.key)}" aria-label="زيادة الكمية">+</button>
          <button type="button" class="gm-cart-drawer-product__remove" data-gm-remove data-key="${escapeHtml(item.key)}" aria-label="حذف المنتج">🗑</button>
        </div>
        <span class="gm-cart-drawer-product__stock-warning" data-gm-stock-warning hidden></span>
      </div>
    `;
    list.appendChild(product);
  });

  loadCartCompareAtPrices(cart, list);
}

var gmCompareAtCache = {};
var gmCompareAtPending = {};

function getCartItemHandle(item) {
  if (!item) return '';
  if (item.handle) return String(item.handle);
  var href = item.url || '';
  if (!href) return '';
  try {
    var url = new URL(href, window.location.origin);
    var match = url.pathname.match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch (error) {
    return '';
  }
}

function fetchProductCompareAt(handle) {
  if (!handle) return Promise.resolve({});
  if (gmCompareAtCache[handle]) return Promise.resolve(gmCompareAtCache[handle]);
  if (gmCompareAtPending[handle]) return gmCompareAtPending[handle];

  gmCompareAtPending[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js?_=' + Date.now(), {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'Accept': 'application/json' }
  }).then(function (response) {
    if (!response.ok) throw new Error('تعذر قراءة سعر المقارنة.');
    return response.json();
  }).then(function (product) {
    var map = {};
    (product && product.variants || []).forEach(function (variant) {
      map[String(variant.id)] = Number(variant.compare_at_price || 0);
    });
    gmCompareAtCache[handle] = map;
    return map;
  }).catch(function () {
    var empty = {};
    gmCompareAtCache[handle] = empty;
    return empty;
  }).finally(function () {
    delete gmCompareAtPending[handle];
  });

  return gmCompareAtPending[handle];
}

function loadCartCompareAtPrices(cart, list) {
  if (!cart || !cart.items || !list) return;

  var handles = {};
  cart.items.forEach(function (item) {
    var handle = getCartItemHandle(item);
    if (handle) handles[handle] = true;
  });

  Object.keys(handles).forEach(function (handle) {
    fetchProductCompareAt(handle).then(function (map) {
      cart.items.forEach(function (item) {
        if (getCartItemHandle(item) !== handle) return;
        var compareAt = Number(map[String(item.variant_id)] || 0);
        var card = qsa('.gm-cart-drawer-product', list).find(function (el) {
          return el.dataset.gmCartKey === item.key;
        });
        if (!card) return;

        var priceWrap = qs('.gm-cart-drawer-product__prices', card);
        if (!priceWrap) return;

        var currentPrice = Number(item.price || item.final_price || 0);
        if (compareAt > currentPrice && compareAt > 0) {
          priceWrap.innerHTML = `
            <strong class="gm-cart-drawer-product__price">${formatMoney(currentPrice)}</strong>
            <del class="gm-cart-drawer-product__compare">${formatMoney(compareAt)}</del>
          `;
        } else {
          priceWrap.innerHTML = `<strong class="gm-cart-drawer-product__price">${formatMoney(currentPrice)}</strong>`;
        }
      });
    });
  });
}

  function showEmptyState(empty) {
    if (!empty) return;
    empty.hidden = false;
    empty.style.display = '';
    empty.setAttribute('aria-hidden', 'false');
  }

  function hideEmptyState(empty) {
    if (!empty) return;
    empty.hidden = true;
    empty.style.display = 'none';
    empty.setAttribute('aria-hidden', 'true');
  }

  function updateEmptyState(cart) {
    var drawer = getDrawer();
    var empty = qs('[data-gm-cart-drawer-empty], [data-gm-cart-empty]', drawer || document);
    if (!cart || !cart.items || !cart.items.length) {
      showEmptyState(empty);
    } else {
      hideEmptyState(empty);
    }
  }

  /* ============================================================
     PRODUCT ACTIONS
  ============================================================ */
  function bindProductActionsDelegated() {
    if (document.documentElement.dataset.gmCartProductEvents === 'true') return;
    document.documentElement.dataset.gmCartProductEvents = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-gm-qty-minus], [data-gm-qty-plus], [data-gm-remove]');
      if (!button || !isInsideDrawer(button)) return;

      var key = button.dataset.key;
      if (!key) return;

      var product = button.closest('.gm-cart-drawer-product');
      var quantityElement = product && product.querySelector('[data-gm-quantity]');
      var current = quantityElement ? parseInt(quantityElement.textContent, 10) : 1;
      if (!Number.isFinite(current)) current = 1;

      if (button.hasAttribute('data-gm-qty-minus')) current = Math.max(current - 1, 0);
      if (button.hasAttribute('data-gm-qty-plus')) current += 1;
      if (button.hasAttribute('data-gm-remove')) current = 0;

      event.preventDefault();
      event.stopPropagation();
      updateItem(key, current);
    });
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (error) { data = {}; }
        if (!response.ok) {
          var stockError = data.description || data.message || 'الكمية المتاحة من هذا المنتج لا تسمح بزيادة الكمية أكثر.';
          var drawer = getDrawer();
          var product = drawer && qsa('.gm-cart-drawer-product', drawer).find(function (card) { return card.dataset.gmCartKey === key; });
          var warning = product && qs('[data-gm-stock-warning]', product);
          if (warning) {
            warning.textContent = stockError;
            warning.hidden = false;
          }
          throw new Error(stockError);
        }
        return data;
      });
    }).then(function (cart) {
      renderProducts(cart);
      updateShipping(cart);
      updateSummary(cart);
      updateCartBubble(cart);
      updateEmptyState(cart);
      renderAOV(cart);
      dispatchCartEvents(cart);
    }).catch(function (error) {
      console.error('GM Cart Drawer Update:', error);
    });
  }

  /* ============================================================
     SHIPPING & SUMMARY
  ============================================================ */
  function updateShipping(cart) {
    var drawer = getDrawer();
    var remaining = qs('[data-gm-shipping-remaining]', drawer || document);
    var progress = qs('[data-gm-shipping-progress]', drawer || document);
    var text = qs('.gm-cart-drawer__shipping-text', drawer || document);
    
    if (!progress) return;
    var total = Number(cart.total_price || 0) / 100;
    var settings = getShippingSettings(drawer);
    
    if (!settings || !Number.isFinite(settings.threshold) || settings.threshold <= 0) return;

    var threshold = settings.threshold;
    var left = Math.max(threshold - total, 0);
    var percentage = Math.min((total / threshold) * 100, 100);

    if (remaining) remaining.textContent = left.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP';
    progress.style.width = percentage + '%';

    // التحكم في لون الشريط (أخضر عند النجاح)
    if (left <= 0) {
      progress.style.background = 'linear-gradient(90deg, #2E7D32 0%, #4CAF50 50%, #2E7D32 100%)';
      progress.style.backgroundSize = '200% 100%';
      progress.style.animation = 'gmCartDrawerShippingFlow 2.2s linear infinite';
    } else {
      progress.style.background = '';
      progress.style.backgroundSize = '';
      progress.style.animation = '';
    }

    if (text) {
      if (left <= 0) {
        if (settings.successColor) text.style.color = settings.successColor;
        if (settings.successSize) text.style.fontSize = settings.successSize + 'px';
        if (settings.successWeight) text.style.fontWeight = settings.successWeight;
        text.innerHTML = '<strong>' + escapeHtml(settings.successText) + '</strong>';
      } else {
        text.style.color = ''; text.style.fontSize = ''; text.style.fontWeight = '';
        text.innerHTML = 'أضف <strong>' + left.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EGP</strong> للحصول على الشحن المجاني';
      }
    }
  }

  function getOfferInfo(cart) {
    var itemCount = Number(cart && cart.item_count || 0);
    var subtotal = Number(cart && (cart.items_subtotal_price || cart.total_price) || 0);
    var discountRate = itemCount >= 3 ? 10 : (itemCount === 2 ? 5 : 0);
    var offerDiscount = discountRate > 0 ? Math.round(subtotal * discountRate / 100) : 0;
    var offerTotal = Math.max(subtotal - offerDiscount, 0);

    return {
      itemCount: itemCount,
      subtotal: subtotal,
      discountRate: discountRate,
      discount: offerDiscount,
      total: offerTotal
    };
  }

  function updateSummary(cart) {
    var drawer = getDrawer();
    var subtotal = qs('[data-gm-summary-subtotal]', drawer || document);
    var total = qs('[data-gm-summary-total]', drawer || document);
    var totalLabel = qs('[data-gm-summary-total-label]', drawer || document);
    var discount = qs('[data-gm-summary-discount]', drawer || document);
    var discountRow = qs('[data-gm-summary-discount-row]', drawer || document);
    var beforeRow = qs('[data-gm-summary-before-row]', drawer || document);
    var offer = qs('[data-gm-summary-offer]', drawer || document);

    var info = getOfferInfo(cart || {});
    var hasOffer = info.discountRate > 0 && info.itemCount >= 2;

    if (subtotal) subtotal.textContent = formatMoney(info.subtotal);
    if (discount) discount.textContent = '-' + formatMoney(info.discount);
    if (total) total.textContent = formatMoney(hasOffer ? info.total : Number(cart && cart.total_price || 0));
    if (totalLabel) totalLabel.textContent = hasOffer ? 'الإجمالي بعد الخصم' : 'الإجمالي';
    if (discountRow) discountRow.hidden = !hasOffer;
    if (beforeRow) beforeRow.hidden = !hasOffer;
    if (offer) offer.hidden = !hasOffer;
  }

  function getOfferDiscountCode(cart) {
    var info = getOfferInfo(cart || {});
    if (info.discountRate <= 0) return '';

    var selectors = info.discountRate >= 10
      ? ['[data-gm-offer][data-discount3]', '[data-gm-offer][data-discount-3]', '[data-discount3]']
      : ['[data-gm-offer][data-discount2]', '[data-gm-offer][data-discount-2]', '[data-discount2]'];

    for (var i = 0; i < selectors.length; i++) {
      var el = qs(selectors[i]);
      if (el) {
        var code = el.dataset.discount3 || el.dataset.discount2 || el.dataset.discount || '';
        if (code) return String(code).trim();
      }
    }

    return '';
  }

  function goToCheckout(cart) {
    var code = getOfferDiscountCode(cart || {});
    if (code) {
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/checkout');
      return;
    }
    window.location.assign('/checkout');
  }

  /* ============================================================
     CART BUBBLE (Background Refresh)
  ============================================================ */
  function updateCartBubble(cart) {
    var count = Math.max(0, Number(cart && cart.item_count || 0));

    /*
     * The cart count is already available in /cart.js. Do not fetch the
     * current page just to rebuild the header icon; that creates an extra
     * full-document request after every cart action.
     *
     * Support both GM's custom counter and Dawn-style cart bubbles.
     */
    var counters = qsa([
      '[data-gm-cart-count]',
      '#cart-icon-bubble .cart-count-bubble',
      '.header__icon--cart .cart-count-bubble',
      '.cart-icon-bubble .cart-count-bubble',
      '.cart-count-bubble'
    ].join(','));

    counters.forEach(function(el) {
      if (isInsideDrawer(el)) return;

      var numericTarget = el.querySelector('[aria-hidden="true"]');
      var visuallyHiddenTarget = el.querySelector('.visually-hidden');

      if (numericTarget) {
        numericTarget.textContent = String(count);
      } else {
        el.textContent = String(count);
      }

      if (visuallyHiddenTarget) {
        visuallyHiddenTarget.textContent = count === 1
          ? '1 item'
          : String(count) + ' items';
      }

      el.hidden = false;
      el.classList.remove('hidden');
    });
  }


  /* ============================================================
     EVENTS DISPATCH
  ============================================================ */
  function dispatchCartEvents(cart) {
    try { document.dispatchEvent(new CustomEvent('gm:cart-updated', { detail: { cart: cart } })); } catch (error) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (error) {}
  }

  /* ============================================================
     AOV — AVERAGE ORDER VALUE
  ============================================================ */
  function getAOVSection() { return qs('[data-gm-cart-section="aov"]'); }
  function getAOVConfig(section) {
    var el = section && qs('[data-gm-aov-config]', section);
    if (!el) return null;
    return {
      limit: Math.max(parseInt(el.dataset.limit || '8', 10) || 8, 1),
      desktopVisible: Math.max(parseInt(el.dataset.desktopVisible || '1', 10) || 1, 1),
      mobileVisible: Math.max(parseInt(el.dataset.mobileVisible || '1', 10) || 1, 1),
      swipe: el.dataset.swipe !== 'false',
      autoplay: el.dataset.autoplay === 'true',
      autoplaySpeed: Math.max(parseInt(el.dataset.autoplaySpeed || '4000', 10) || 4000, 1000),
      showArrows: el.dataset.showArrows !== 'false',
      showDots: el.dataset.showDots !== 'false',
      showQuickView: el.dataset.showQuickView !== 'false',
      addButtonText: el.dataset.addButtonText || 'إضافة للسلة',
      quickViewAddText: el.dataset.quickViewAddText || 'إضافة للسلة',
      emptyText: el.dataset.emptyText || 'لا توجد منتجات إضافية مناسبة حاليًا.'
    };
  }

  function getAOVVisible(section) {
    var config = getAOVConfig(section);
    if (!config) return 1;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    return Math.max(1, mobile ? config.mobileVisible : config.desktopVisible);
  }

  function getAOVProducts(section, cart) {
    var list = qs('[data-gm-aov-products]', section);
    if (!list) return [];
    var inCart = {};
    (cart && cart.items || []).forEach(function (item) {
      if (item && item.variant_id) inCart[String(item.variant_id)] = true;
    });
    return qsa('[data-gm-aov-product]', list).filter(function (card) {
      return (card.dataset.variantId && !inCart[String(card.dataset.variantId)]);
    }).slice(0, getAOVConfig(section).limit);
  }

  function getAOVSourceByVariant(section, variantId) {
    var list = qs('[data-gm-aov-products]', section);
    if (!list) return null;
    return qsa('[data-gm-aov-product]', list).find(function (source) {
      return (String(source.dataset.variantId || '') === String(variantId || ''));
    }) || null;
  }

  function getAOVQuickView(section) { return qs('[data-gm-aov-quickview]', section); }
  
  function closeAOVQuickView(section) {
    var modal = getAOVQuickView(section);
    if (!modal) return false;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (section && section._gmAOVState) {
      section._gmAOVState.quickViewVariant = null;
      section._gmAOVState.quickViewQuantity = 1;
    }
    return true;
  }

  function openAOVQuickView(section, source) {
    if (!section || !source) return;
    var modal = getAOVQuickView(section);
    if (!modal) return;
    
    var image = qs('[data-gm-aov-quickview-image]', modal);
    var title = qs('[data-gm-aov-quickview-title]', modal);
    var price = qs('[data-gm-aov-quickview-price]', modal);
    var compare = qs('[data-gm-aov-quickview-compare]', modal);
    var quantity = qs('[data-gm-aov-quickview-quantity]', modal);
    var add = qs('[data-gm-aov-quickview-add]', modal);
    var links = qsa('[data-gm-aov-quickview-link]', modal); 
    var state = section._gmAOVState || {};
    
    state.quickViewVariant = source.dataset.variantId || '';
    state.quickViewQuantity = 1;
    section._gmAOVState = state;

    if (image) { image.src = source.dataset.image || ''; image.alt = source.dataset.title || ''; image.hidden = !source.dataset.image; }
    if (title) title.textContent = source.dataset.title || '';
    if (price) price.textContent = formatMoney(source.dataset.price || '0');
    if (compare) {
      if (Number(source.dataset.compare || '0') > Number(source.dataset.price || '0')) {
        compare.hidden = false;
        compare.textContent = formatMoney(source.dataset.compare || '0');
      } else { compare.hidden = true; compare.textContent = ''; }
    }
    if (quantity) quantity.textContent = '1';
    if (add) { add.textContent = getAOVConfig(section).quickViewAddText; add.disabled = false; }
    
    links.forEach(function(link) {
      link.href = source.dataset.url || '#';
    });
    
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
  }

  function updateAOVQuickViewQuantity(section, change) {
    var state = section && section._gmAOVState;
    if (!state) return;
    var next = Number(state.quickViewQuantity || 1) + Number(change || 0);
    next = Math.max(1, Math.min(next, 99));
    state.quickViewQuantity = next;
    var quantity = qs('[data-gm-aov-quickview-quantity]', section);
    if (quantity) quantity.textContent = String(next);
  }

  function addAOVQuickViewToCart(section) {
    var state = section && section._gmAOVState;
    if (!state || !state.quickViewVariant) return;
    var button = qs('[data-gm-aov-quickview-add]', section);
    var quantity = Math.max(1, Number(state.quickViewQuantity || 1));
    
    setButtonLoading(button, true);
    addVariantToShopifyCart(state.quickViewVariant, quantity).then(function () {
      closeAOVQuickView(section);
      return refreshCart();
    }).catch(function (error) { console.error('GM AOV Quick View Add:', error); }).finally(function () {
      setButtonLoading(button, false);
    });
  }

  function updateAOVCarousel(section) {
    if (!section) return;
    var track = qs('[data-gm-aov-track]', section);
    var cards = qsa('.gm-cart-drawer-aov__product', section);
    if (!track || !cards.length) return;

    var visible = Math.min(getAOVVisible(section), cards.length);
    var max = Math.max(cards.length - visible, 0);
    var state = section._gmAOVState || { index: 0, timer: null, startX: 0, startY: 0, quickViewVariant: null, quickViewQuantity: 1 };
    state.index = Math.max(0, Math.min(state.index, max));
    section._gmAOVState = state;

    track.style.width = (cards.length * (100 / visible)) + '%';
    track.style.transform = 'translate3d(-' + (state.index * (100 / cards.length)) + '%,0,0)';

    var config = getAOVConfig(section);
    var prev = qs('[data-gm-aov-prev]', section);
    var next = qs('[data-gm-aov-next]', section);
    var dots = qs('[data-gm-aov-dots]', section);

    if (prev) prev.hidden = !config.showArrows || max === 0;
    if (next) next.hidden = !config.showArrows || max === 0;
    if (dots) {
      dots.hidden = !config.showDots || max === 0;
      qsa('[data-gm-aov-dot]', dots).forEach(function (dot, index) { dot.classList.toggle('is-active', index === state.index); });
    }
  }

  function startAOVAutoplay(section) {
    var config = getAOVConfig(section);
    var state = section && section._gmAOVState;
    if (!state) return;
    if (state.timer) { window.clearInterval(state.timer); state.timer = null; }
    if (!config.autoplay) return;

    if (document.hidden) return;

    state.timer = window.setInterval(function () {
      if (document.hidden) return;
      var cards = qsa('.gm-cart-drawer-aov__product', section);
      var visible = Math.min(getAOVVisible(section), cards.length);
      var max = Math.max(cards.length - visible, 0);
      if (!max) return;
      state.index = state.index >= max ? 0 : state.index + 1;
      updateAOVCarousel(section);
    }, config.autoplaySpeed);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      qsa('[data-gm-aov-products]').forEach(function (section) {
        var state = section._gmAOVState;
        if (state && state.timer) {
          window.clearInterval(state.timer);
          state.timer = null;
        }
      });
    } else {
      qsa('[data-gm-aov-products]').forEach(function (section) {
        startAOVAutoplay(section);
      });
    }
  });

  function renderAOV(cart) {
    var section = getAOVSection();
    if (!section) return;
    var config = getAOVConfig(section);
    var list = qs('[data-gm-aov-products]', section);
    var track = qs('[data-gm-aov-track]', section);
    var viewport = qs('[data-gm-aov-viewport]', section);
    if (!config || !list || !track || !viewport) return;

    var products = getAOVProducts(section, cart);
    track.innerHTML = '';
    section.style.setProperty('--gm-aov-card-count', Math.max(products.length, 1));

    products.forEach(function (source) {
      var card = document.createElement('article');
      card.className = 'gm-cart-drawer-aov__product';
      card.dataset.variantId = source.dataset.variantId;
      var title = source.dataset.title || '';
      var price = source.dataset.price || '0';
      var compare = source.dataset.compare || '0';
      var image = source.dataset.image || '';
      var variantId = source.dataset.variantId || '';

      card.innerHTML = `
        <a href="${escapeHtml(source.dataset.url || '#')}" class="gm-cart-drawer-aov__product-image" aria-label="عرض: ${escapeHtml(title)}">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy">` : ''}
        </a>
        <div class="gm-cart-drawer-aov__product-info">
          ${source.dataset.url ? `<a class="gm-cart-drawer-aov__product-title" href="${escapeHtml(source.dataset.url)}">${escapeHtml(title)}</a>` : `<div class="gm-cart-drawer-aov__product-title">${escapeHtml(title)}</div>`}
          <div class="gm-cart-drawer-aov__product-prices">
            <strong>${formatMoney(price)}</strong>
      ${Number(compare) > Number(price) ? `<del>${formatMoney(compare)}</del> <span style="font-size:10px;color:#E53935;font-weight:700;margin-right:4px;">خصم</span>` : ''}
          </div>
          ${config.showQuickView ? `<div class="gm-cart-drawer-aov__product-actions"><button type="button" class="gm-cart-drawer-aov__quickview-trigger" data-gm-aov-quick-view data-variant-id="${escapeHtml(variantId)}" aria-label="عرض سريع: ${escapeHtml(title)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.5"></circle></svg></button></div>` : ''}
        </div>
      `;
      track.appendChild(card);
    });

    section.classList.toggle('gm-aov-empty', !products.length);
    var emptyText = qs('[data-gm-aov-empty]', section);
    if (emptyText) { emptyText.textContent = config.emptyText; emptyText.hidden = !!products.length; }

    var state = section._gmAOVState || { index: 0, timer: null, startX: 0, startY: 0, quickViewVariant: null, quickViewQuantity: 1 };
    state.index = 0;
    section._gmAOVState = state;

    var visible = Math.min(getAOVVisible(section), products.length);
    if (visible) {
      section.style.setProperty('--gm-aov-visible', visible);
      section.style.setProperty('--gm-aov-card-count', products.length);
    }

    var dots = qs('[data-gm-aov-dots]', section);
    if (dots) {
      dots.innerHTML = '';
      var max = Math.max(products.length - visible, 0);
      for (var i = 0; i <= max; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.gmAovDot = String(i);
        dot.setAttribute('aria-label', 'عرض المنتجات ' + (i + 1));
        dot.addEventListener('click', function () {
          section._gmAOVState.index = parseInt(this.dataset.gmAovDot, 10) || 0;
          updateAOVCarousel(section);
          startAOVAutoplay(section);
        });
        dots.appendChild(dot);
      }
    }

    if (!section.dataset.gmAovControlsBound) {
      section.dataset.gmAovControlsBound = 'true';
      var prev = qs('[data-gm-aov-prev]', section);
      var next = qs('[data-gm-aov-next]', section);

      if (prev) { prev.addEventListener('click', function () { section._gmAOVState.index--; updateAOVCarousel(section); startAOVAutoplay(section); }); }
      if (next) { next.addEventListener('click', function () { section._gmAOVState.index++; updateAOVCarousel(section); startAOVAutoplay(section); }); }

      if (config.swipe) {
        viewport.addEventListener('pointerdown', function (event) { section._gmAOVState.startX = event.clientX; section._gmAOVState.startY = event.clientY; });
        viewport.addEventListener('pointerup', function (event) {
          var s = section._gmAOVState;
          var dx = event.clientX - s.startX;
          var dy = event.clientY - s.startY;
          if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) s.index++; else s.index--;
          updateAOVCarousel(section);
          startAOVAutoplay(section);
        });
      }

      section.addEventListener('click', function (event) {
        var quickViewTrigger = event.target.closest('[data-gm-aov-quick-view]');
        if (quickViewTrigger) {
          event.preventDefault(); event.stopPropagation();
          var source = getAOVSourceByVariant(section, quickViewTrigger.dataset.variantId);
          if (source) openAOVQuickView(section, source);
          return;
        }

        var closeTrigger = event.target.closest('[data-gm-aov-quickview-close]');
        if (closeTrigger) { event.preventDefault(); event.stopPropagation(); closeAOVQuickView(section); return; }

        var minus = event.target.closest('[data-gm-aov-qty-minus]');
        if (minus) { event.preventDefault(); event.stopPropagation(); updateAOVQuickViewQuantity(section, -1); return; }

        var plus = event.target.closest('[data-gm-aov-qty-plus]');
        if (plus) { event.preventDefault(); event.stopPropagation(); updateAOVQuickViewQuantity(section, 1); return; }

        var quickViewAdd = event.target.closest('[data-gm-aov-quickview-add]');
        if (quickViewAdd) { event.preventDefault(); event.stopPropagation(); addAOVQuickViewToCart(section); return; }

        var button = event.target.closest('[data-gm-aov-add]');
        if (!button) return;
        event.preventDefault(); event.stopPropagation();
        var variantId = button.dataset.variantId;
        if (!variantId) return;

        setButtonLoading(button, true);
        addVariantToShopifyCart(variantId, 1).then(function () { return refreshCart(); }).catch(function (error) { console.error('GM AOV Add:', error); }).finally(function () { setButtonLoading(button, false); });
      });

      section.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var modal = getAOVQuickView(section);
        if (modal && !modal.hidden) { event.preventDefault(); event.stopPropagation(); closeAOVQuickView(section); }
      });
    }

    updateAOVCarousel(section);
    startAOVAutoplay(section);
  }

  /* ============================================================
     MOUNT SECTIONS
  ============================================================ */
  function mountSections() {
    var mappings = [
      { source: '[data-gm-cart-section="aov"]', target: '[data-gm-cart-drawer-slot="aov"]' },
      { source: '[data-gm-cart-section="summary"]', target: '[data-gm-cart-drawer-slot="summary"]' },
      { source: '[data-gm-cart-section="actions"]', target: '[data-gm-cart-drawer-slot="actions"]' }
    ];

    mappings.forEach(function (mapping) {
      var source = qs(mapping.source);
      var target = qs(mapping.target);
      if (!source || !target || target.contains(source)) return;
      source.hidden = false;
      source.style.display = '';
      target.appendChild(source);
    });
  }

  /* ============================================================
     PRODUCT STYLES
  ============================================================ */
function injectProductStyles() {
  if (document.getElementById('gm-cart-drawer-product-styles')) return;
  var style = document.createElement('style');
  style.id = 'gm-cart-drawer-product-styles';
  style.textContent = `
    [data-gm-cart-drawer-empty][hidden], [data-gm-cart-empty][hidden] { display: none !important; }

    /* ===== Product Card ===== */
    .gm-cart-drawer-product {
      direction: rtl;
      position: relative;
      display: flex;
      align-items: center;
      gap: 14px;
      padding: var(--gm-product-card-padding);
      border-bottom: 1px solid #eeeeee;
      background: #fff;
      box-sizing: border-box;
    }

    /* زر الإغلاق (X) فوق الكارت */
    .gm-cart-drawer-product__close {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 30px;
      height: 30px;
      padding: 0;
      border: 0;
      background: transparent;
      color: #777;
      cursor: pointer;
      display: grid;
      place-items: center;
      border-radius: 50%;
      transition: background .2s ease, color .2s ease;
      z-index: 3;
    }
    .gm-cart-drawer-product__close:hover {
      background: #f5f5f5;
      color: #111;
    }
    .gm-cart-drawer-product__close svg {
      width: 18px;
      height: 18px;
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      stroke-linecap: round;
    }

    /* ===== Image ===== */
    .gm-cart-drawer-product__image {
      width: var(--gm-product-image-width);
      min-width: var(--gm-product-image-width);
      height: var(--gm-product-image-width);
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      flex: 0 0 auto;
    }
    .gm-cart-drawer-product__image img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    /* ===== Info ===== */
    .gm-cart-drawer-product__info {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .gm-cart-drawer-product__title {
      font-size: var(--gm-product-title-size);
      line-height: 1.45;
      font-weight: var(--gm-product-title-weight);
      color: var(--gm-product-title-color);
      text-decoration: none;
    }
    .gm-cart-drawer-product__variant {
      margin-top: 4px;
      font-size: var(--gm-product-variant-size);
      line-height: 1.4;
      color: var(--gm-product-variant-color);
    }

    /* ===== Prices ===== */
    .gm-cart-drawer-product__prices {
      display: flex;
      align-items: baseline;
      gap: 8px;
      flex-wrap: wrap;
      margin-top: 7px;
      direction: rtl;
    }
    .gm-cart-drawer-product__price {
      font-size: var(--gm-product-price-size);
      font-weight: 700;
      color: var(--gm-product-price-color);
    }
    .gm-cart-drawer-product__compare {
      font-size: var(--gm-product-compare-size);
      color: var(--gm-product-compare-color);
      text-decoration: line-through;
    }

    /* ===== Quantity + Remove Control ===== */
    .gm-cart-drawer-product__controls {
      display: inline-flex;
      align-items: center;
      width: fit-content;
      margin-top: 10px;
      border: 1px solid var(--gm-quantity-border-color);
      border-radius: 6px;
      overflow: hidden;
      background: #fff;
    }
    .gm-cart-drawer-product__controls button {
      width: var(--gm-quantity-button-size);
      height: var(--gm-quantity-button-size);
      padding: 0;
      border: 0;
      background: #fff;
      color: var(--gm-quantity-text-color);
      font-size: 18px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: background .15s ease;
    }
    .gm-cart-drawer-product__controls button:hover {
      background: #f7f7f7;
    }
    .gm-cart-drawer-product__controls span[data-gm-quantity] {
      min-width: 30px;
      text-align: center;
      font-size: var(--gm-quantity-font-size);
      color: var(--gm-quantity-text-color);
    }
    .gm-cart-drawer-product__controls .gm-cart-drawer-product__remove {
      margin-inline-start: 4px;
      border-inline-start: 1px solid #e5e5e5;
      font-size: 14px;
      color: var(--gm-remove-color);
      padding: 0 8px;
    }

    /* ===== Stock Warning ===== */
    .gm-cart-drawer-product__stock-warning {
      display: block;
      margin-top: 7px;
      font-size: 12px;
      line-height: 1.4;
      color: #b42318;
      font-weight: 600;
    }

    /* ===== Mobile ===== */
    @media (max-width: 600px) {
      .gm-cart-drawer-product {
        padding: var(--gm-product-card-padding);
        gap: var(--gm-product-card-gap);
      }
      .gm-cart-drawer-product__image {
        width: var(--gm-product-image-width-mobile);
        min-width: var(--gm-product-image-width-mobile);
        height: var(--gm-product-image-width-mobile);
      }
      .gm-cart-drawer-product__title {
        font-size: var(--gm-product-title-size);
      }
      .gm-cart-drawer-product__variant {
        font-size: var(--gm-product-variant-size);
      }
      .gm-cart-drawer-product__price {
        font-size: var(--gm-product-price-size);
      }
    }
  `;
  document.head.appendChild(style);
}

  /* ============================================================
     BOOT
  ============================================================ */
  function init() {
    if (GM.initialized) return;
    GM.initialized = true;

    bindGlobalEvents();
    bindProductActionsDelegated();
    mountSections();
    bindDrawerEvents();
    injectProductStyles();
    renderAOV({ items: [] });

    /* Cart data is fetched on demand when the drawer opens or an item is added. */
  }

  /* ============================================================
     PUBLIC API
  ============================================================ */
  GM.open = open;
  GM.close = close;
  GM.refresh = refreshCart;
  GM.getCart = fetchCart;
  GM.add = function (variantId, quantity) {
    return addVariantToShopifyCart(variantId, quantity || 1).then(afterAdd);
  };

  /* ============================================================
     START
  ============================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();